import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = 'https://businessprideindia.com/bu_images/logo-bp.jpeg';

// Inline SVG social icons (no external dependency)
const SocialIcons = {
  Facebook: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.15 8.44 9.94v-7.03H7.9v-2.9h2.54V9.85c0-2.52 1.5-3.91 3.78-3.91 1.1 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.9h2.78l-.44 2.9h-2.34V22c4.78-.79 8.43-4.94 8.43-9.94z"/>
    </svg>
  ),
  Instagram: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 2.2c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.21 15.58 2.2 15.2 2.2 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.21 8.8 2.2 12 2.2zm0 1.8c-3.15 0-3.5.01-4.74.07-1.14.05-1.76.24-2.17.4-.55.21-.94.47-1.35.88-.41.41-.67.8-.88 1.35-.16.41-.35 1.03-.4 2.17C2.4 8.5 2.4 8.85 2.4 12s.01 3.5.07 4.74c.05 1.14.24 1.76.4 2.17.21.55.47.94.88 1.35.41.41.8.67 1.35.88.41.16 1.03.35 2.17.4 1.24.06 1.59.07 4.74.07s3.5-.01 4.74-.07c1.14-.05 1.76-.24 2.17-.4.55-.21.94-.47 1.35-.88.41-.41.67-.8.88-1.35.16-.41.35-1.03.4-2.17.06-1.24.07-1.59.07-4.74s-.01-3.5-.07-4.74c-.05-1.14-.24-1.76-.4-2.17a3.6 3.6 0 0 0-.88-1.35 3.6 3.6 0 0 0-1.35-.88c-.41-.16-1.03-.35-2.17-.4C15.5 4.01 15.15 4 12 4zm0 3.06a4.94 4.94 0 1 1 0 9.88 4.94 4.94 0 0 1 0-9.88zm0 1.8a3.14 3.14 0 1 0 0 6.28 3.14 3.14 0 0 0 0-6.28zm5.15-2.85a1.15 1.15 0 1 1 0 2.3 1.15 1.15 0 0 1 0-2.3z"/>
    </svg>
  ),
  Twitter: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M18.24 2.25h3.31l-7.23 8.26 8.5 11.24h-6.66l-5.22-6.82-5.97 6.82H1.66l7.73-8.84L1.25 2.25h6.83l4.72 6.24 5.44-6.24zm-1.16 17.52h1.83L7.01 4.13H5.05l12.03 15.64z"/>
    </svg>
  ),
  LinkedIn: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.35V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.55V9h3.57v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0z"/>
    </svg>
  ),
  YouTube: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M23.5 6.2a3.02 3.02 0 0 0-2.12-2.14C19.5 3.55 12 3.55 12 3.55s-7.5 0-9.38.51A3.02 3.02 0 0 0 .5 6.2C0 8.08 0 12 0 12s0 3.92.5 5.8a3.02 3.02 0 0 0 2.12 2.14c1.88.51 9.38.51 9.38.51s7.5 0 9.38-.51a3.02 3.02 0 0 0 2.12-2.14C24 15.92 24 12 24 12s0-3.92-.5-5.8zM9.55 15.57V8.43L15.82 12l-6.27 3.57z"/>
    </svg>
  ),
  Mail: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="2" y="4" width="20" height="16" rx="2"/>
      <path d="M22 6l-10 7L2 6"/>
    </svg>
  ),
  Phone: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
  ),
  MapPin: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
      <circle cx="12" cy="10" r="3"/>
    </svg>
  ),
  WhatsApp: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.03 1-1.03 2.45 0 1.45 1.05 2.85 1.2 3.05.15.2 2.07 3.17 5.02 4.44.7.3 1.25.48 1.68.62.7.22 1.35.19 1.86.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.05 2.1a9.9 9.9 0 0 0-8.45 15.13L2.05 22l4.9-1.53a9.9 9.9 0 0 0 5.1 1.41h.01a9.9 9.9 0 0 0 0-19.78zm0 18.06h-.01c-1.6 0-3.18-.43-4.55-1.25l-.33-.19-3.4 1.06 1.06-3.32-.22-.34a8.24 8.24 0 0 1-1.26-4.4 8.24 8.24 0 0 1 8.24-8.24 8.24 8.24 0 0 1 8.24 8.24 8.24 8.24 0 0 1-7.77 8.24z"/>
    </svg>
  ),
};

// Footer-specific styles
const footerStyle = `
  .ap-footer {
    background: linear-gradient(180deg, #0f172a 0%, #1a2238 100%);
    color: #cbd5e1;
    padding: 3rem 0 1.5rem;
    position: relative;
    overflow: hidden;
  }
  .ap-footer::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 4px;
    background: linear-gradient(90deg, #4338CA, #818CF8, #A78BFA, #818CF8, #4338CA);
    background-size: 200% 100%;
    animation: footerGradient 6s linear infinite;
  }
  @keyframes footerGradient {
    0% { background-position: 0% 50%; }
    100% { background-position: 200% 50%; }
  }

  .ap-footer h5 {
    color: #ffffff;
    font-weight: 700;
    letter-spacing: -0.01em;
    position: relative;
    padding-bottom: 0.5rem;
  }
  .ap-footer h5::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 32px;
    height: 3px;
    border-radius: 2px;
    background: linear-gradient(90deg, #818CF8, #A78BFA);
  }

  .ap-footer a {
    color: #cbd5e1;
    text-decoration: none;
    transition: color 0.2s ease, padding-left 0.2s ease;
  }
  .ap-footer ul a:hover {
    color: #ffffff;
    padding-left: 4px;
  }
  .footer-contact-link {
    color: #e2e8f0 !important;
    border-bottom: 1px dashed transparent;
  }
  .footer-contact-link:hover {
    color: #A5B4FC !important;
    border-bottom-color: #A5B4FC;
  }

  .footer-brand {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1rem;
  }
  .footer-logo {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 22px -8px rgba(99, 102, 241, 0.7);
    flex-shrink: 0;
    overflow: hidden;
    padding: 4px;
  }
  .footer-logo img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
  .footer-brand-text {
    display: flex;
    flex-direction: column;
    line-height: 1.1;
  }
  .footer-brand-name {
    font-weight: 800;
    color: #ffffff;
    font-size: 1.05rem;
    letter-spacing: -0.01em;
  }
  .footer-brand-tag {
    font-size: 0.72rem;
    color: #94a3b8;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    font-weight: 600;
    margin-top: 2px;
  }

  .footer-desc {
    color: #94a3b8;
    font-size: 0.86rem;
    line-height: 1.65;
    text-align: justify;
    text-justify: inter-word;
    margin-bottom: 0;
  }

  .footer-contact-item {
    display: flex;
    align-items: flex-start;
    gap: 0.65rem;
    margin-bottom: 0.85rem;
    font-size: 0.86rem;
    color: #cbd5e1;
    line-height: 1.5;
  }
  .footer-contact-icon {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: rgba(99, 102, 241, 0.15);
    color: #A5B4FC;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 1px;
  }
  .footer-contact-icon svg { width: 15px; height: 15px; }

  .footer-social-row {
    display: flex;
    gap: 0.5rem;
    margin-top: 1rem;
  }
  .footer-social-btn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #cbd5e1;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.08);
    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .footer-social-btn svg { width: 16px; height: 16px; }
  .footer-social-btn:hover {
    transform: translateY(-3px);
    color: #fff;
    background: linear-gradient(135deg, #4338CA, #818CF8);
    border-color: transparent;
    box-shadow: 0 10px 22px -8px rgba(99, 102, 241, 0.8);
  }
  .footer-social-wa:hover {
    background: linear-gradient(135deg, #25D366, #128C7E);
    box-shadow: 0 10px 22px -8px rgba(18, 140, 126, 0.8);
  }

  .ap-footer hr {
    border-color: rgba(255, 255, 255, 0.08) !important;
    opacity: 1;
  }
  .footer-bottom {
    color: #94a3b8;
    font-size: 0.82rem;
  }
  .footer-bottom strong { color: #e2e8f0; }
`;

export default function Footer() {
  return (
    <footer className="ap-footer mt-5" data-testid="site-footer">
      <style>{footerStyle}</style>
      <div className="container">
        <div className="row g-4">
          {/* Brand + description */}
          <div className="col-md-4">
            <div className="footer-brand">
              <div className="footer-logo">
                <img src={LOGO_URL} alt="Business Pride India logo" />
              </div>
              <div className="footer-brand-text">
                <span className="footer-brand-name">Business Pride India</span>
                <span className="footer-brand-tag">Local · Trusted · Verified</span>
              </div>
            </div>
            <p className="footer-desc">
              Business Pride India is a platform dedicated to promoting businesses, brands and
              entrepreneurs through online visibility and magazine features. We help businesses
              showcase their products, services and achievements to a wider audience, build brand
              recognition and create new growth opportunities through online and offline promotion.
            </p>
            <div className="footer-social-row" aria-label="Social media">
              <a
                href="https://wa.me/917013701057"
                target="_blank"
                rel="noreferrer"
                className="footer-social-btn footer-social-wa"
                aria-label="WhatsApp"
                title="WhatsApp"
              >
                <SocialIcons.WhatsApp />
              </a>
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noreferrer"
                className="footer-social-btn"
                aria-label="Facebook"
                title="Facebook"
              >
                <SocialIcons.Facebook />
              </a>
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noreferrer"
                className="footer-social-btn"
                aria-label="Instagram"
                title="Instagram"
              >
                <SocialIcons.Instagram />
              </a>
              <a
                href="https://twitter.com/"
                target="_blank"
                rel="noreferrer"
                className="footer-social-btn"
                aria-label="X (Twitter)"
                title="X (Twitter)"
              >
                <SocialIcons.Twitter />
              </a>
              <a
                href="https://www.linkedin.com/"
                target="_blank"
                rel="noreferrer"
                className="footer-social-btn"
                aria-label="LinkedIn"
                title="LinkedIn"
              >
                <SocialIcons.LinkedIn />
              </a>
              <a
                href="https://www.youtube.com/"
                target="_blank"
                rel="noreferrer"
                className="footer-social-btn"
                aria-label="YouTube"
                title="YouTube"
              >
                <SocialIcons.YouTube />
              </a>
            </div>
          </div>

          {/* Explore links */}
          <div className="col-md-2">
            <h5 className="mb-2">Explore</h5>
            <ul className="list-unstyled small">
              <li><Link to="/search">Browse</Link></li>
              <li><Link to="/categories">Categories</Link></li>
              <li><Link to="/cities">Cities</Link></li>
              <li><Link to="/payments">Payments</Link></li>
            </ul>
          </div>

          {/* Business links */}
          <div className="col-md-3">
            <h5 className="mb-2">Business</h5>
            <ul className="list-unstyled small">
              <li><Link to="/register">List your business</Link></li>
              <li><Link to="/login">Owner login</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-md-3">
            <h5 className="mb-3">Contact</h5>

            <div className="footer-contact-item">
              <span className="footer-contact-icon"><SocialIcons.MapPin /></span>
              <span>
                Office no. 5 &amp; 6, 3rd Floor, Star Tower, 1113/1,
                Panch Bunglow, Shahupuri, Kolhapur-416001
              </span>
            </div>

            <div className="footer-contact-item">
              <span className="footer-contact-icon"><SocialIcons.Mail /></span>
              <a
                href="mailto:info@businessprideindia.com"
                className="footer-contact-link"
              >
                info@businessprideindia.com
              </a>
            </div>

            <div className="footer-contact-item">
              <span className="footer-contact-icon"><SocialIcons.Phone /></span>
              <span>
                <a
                  href="tel:+917013701057"
                  className="footer-contact-link"
                  aria-label="Call +91 7013701057"
                >
                  +91 7013701057
                </a>
                <br />
                <a
                  href="tel:+919156440169"
                  className="footer-contact-link"
                  aria-label="Call +91 9156440169"
                >
                  +91 9156440169
                </a>
              </span>
            </div>

            <div className="footer-contact-item">
              <span className="footer-contact-icon"><SocialIcons.Phone /></span>
              <span>
                <span className="fw-semibold" style={{ color: '#e2e8f0' }}>Toll Free / Office 24/7</span>
                <br />
                <a
                  href="tel:02312664275"
                  className="footer-contact-link"
                  aria-label="Call 0231-2664275"
                >
                  0231-2664275
                </a>
              </span>
            </div>
          </div>
        </div>

        <hr className="mt-4 mb-3" />

        <div className="d-flex flex-column flex-md-row justify-content-between gap-2 footer-bottom">
          <span>
            © {new Date().getFullYear()} <strong>Business Pride India</strong>. All rights reserved.
          </span>
          <span>Made with <span style={{ color: '#f472b6' }}>♥</span> in India</span>
        </div>
      </div>
    </footer>
  );
}